import Component from '@bythepixel/component-loader';
import MicroModal from 'micromodal';
import { lazyLoadIframeInModal } from '@Utility';
import { Events } from './events';

const openClass = 'modal--open';
const successClass = 'modal--success';

export default class MicroModalAdaptor extends Component {
  static selector = '[data-comp-modal-trigger]';

  constructor(...args) {
    super(...args);
    this.modalId = `${this.$container.dataset.compModalTrigger}-modal`;
    this.modalContainer = document.getElementById(this.modalId);

    // Added in https://github.com/bythepixel/transwest-web/pull/3027
    // Prior to this update, we awaited close animations on all modals. This is awkward,
    // but effectively makes 'true' the default state.
    this.awaitCloseAnimation = this.$container.dataset.awaitCloseAnimation !== 'false';

    this.isFacetedSearchPage = document.querySelector(
      '[data-comp-faceted-search]',
    );

    if (!this.modalContainer) {
      console.warn(
        `[MicroModalAdaptor] Modal with id '${this.modalId} is not found.`,
      );
      return;
    }

    this.video = this.modalContainer.querySelector('[data-modal-iframe-src]');
    this.modalController = MicroModal;
    this.modalCloseTriggers = this.modalContainer.querySelectorAll(
      '[data-comp-modal-close-trigger]',
    );

    // For faceted search filter modal
    this.facetedSearchResultsButton = this.modalContainer.querySelectorAll(
      '[data-comp-modal-results-button]',
    );

    this.boundApplyHiddenStyles = () => this.applyHiddenStyles();
    this.initializeFacetedSearch();
    this.events();
  }

  initializeYTPlayer() {
    if (!this.video) {
      return;
    }

    if (window.YT) {
      window.YT.ready(() => {
        lazyLoadIframeInModal(this.video, () => {
          const player = new window.YT.Player(this.video);

          window.ModalYoutubeVideo = player;
          window.YoutubePlayers.push(player);
        });
      });
    }
  }

  show() {
    this.modalController.show(this.modalId, {
      onClose: () => {
        if (
          window.ModalYoutubeVideo
          && typeof window.ModalYoutubeVideo.pauseVideo === 'function'
        ) {
          window.ModalYoutubeVideo.pauseVideo();
        }

        if (
          window.MediaGalleryYoutubeVideo
          && typeof window.MediaGalleryYoutubeVideo.seekTo === 'function'
          && typeof window.MediaGalleryYoutubeVideo.pauseVideo === 'function'
        ) {
          window.MediaGalleryYoutubeVideo.seekTo(0);
          window.MediaGalleryYoutubeVideo.pauseVideo();
        }

        if (this.isFacetedSearchPage) {
          // For faceted search, when a modal closes, collapse all filters
          this.facetedSearchCollapsible?.forEach((collapsible) => {
            const content = collapsible.querySelector(
              '[data-comp-collapsible-text-content]',
            );
            const toggle = collapsible.querySelector(
              '[data-comp-collapsible-text-toggle]',
            );

            if (collapsible.dataset.collapsed === 'false') {
              content.classList.remove('max-lines__expanded');
              toggle.innerText = collapsible.dataset.expandText;
              // eslint-disable-next-line no-param-reassign
              collapsible.dataset.collapsed = 'true';
            }
          });
        }
      },
      awaitCloseAnimation: this.awaitCloseAnimation,
      disableScroll: true,
      openClass,
    });

    window.dispatchEvent(Events.Opened(this.modalId));

    this.initializeYTPlayer();

    // Autoplay video if defined and reload iframe if it hasn't loaded
    const autoplay = this.video && this.video.dataset.modalIframeAutoplay !== undefined;
    if (
      autoplay
      && window.ModalYoutubeVideo
      && typeof window.ModalYoutubeVideo.playVideo === 'function'
    ) {
      window.ModalYoutubeVideo.playVideo();
    }
  }

  close() {
    this.modalController.close(this.modalId);

    window.dispatchEvent(Events.Closed(this.modalId));

    if (this.awaitCloseAnimation) {
      this.modalContainer.addEventListener(
        'animationend',
        this.boundApplyHiddenStyles,
      );
    }

    // Only contact form modals have a success class
    if (this.modalContainer.classList.contains(successClass)) {
      // Wait a bit before removing this class to account for the fade-out transition
      setTimeout(() => {
        this.modalContainer.classList.remove(successClass);
      }, 400);
    }
  }

  applyHiddenStyles() {
    this.modalContainer.removeEventListener(
      'animationend',
      this.boundApplyHiddenStyles,
    );
    this.modalContainer.classList.remove(openClass);
  }

  events() {
    this.$container.addEventListener('click', () => this.show());
    this.modalCloseTriggers.forEach((el) => el.addEventListener('click', () => this.close()));

    // If this is a faceted search filter modal, also close the modal when the user clicks to show results
    this.facetedSearchResultsButton.forEach((el) => {
      el.addEventListener('click', () => this.close());
    });
  }

  initializeFacetedSearch() {
    if (!this.isFacetedSearchPage) {
      return;
    }

    this.facetedSearchCollapsible = this.modalContainer.querySelectorAll(
      '[data-comp-collapsible-text]',
    );
  }
}
